import React, { Fragment, useState, useEffect } from "react";
import { Menu as MenuIcon, Close as CloseIcon } from "@mui/icons-material";
import { Button } from "@ADC/components/common";
import { Drawer } from "@mui/material";
import { Link } from "gatsby";

const MainNavbar = ({
  isApplyPage,
  is404Page,
  showLinks = true,
  phoneNumber = "800-816-1003",
}) => {
  const [open, setOpen] = useState(false);
  const links = [
    {
      name: "Home",
      path: "/",
    },
    {
      name: "Apply",
      path: "/apply/",
    },
    {
      name: "FAQ",
      path: "/faq/",
    },
    {
      name: "Service Areas",
      path: "/service-areas/",
    },
    {
      name: "Blogs",
      path: "/blogs/",
    },
    {
      name: "Contact Us",
      path: "/contact-us/",
    },
  ];
  const toggleDrawer = () => setOpen(!open);

  const [pageScrolled, setPageScrolled] = useState(false);

  const handleScroll = () => {
    const currentScrollY = window.scrollY;
    if (currentScrollY > 60) {
      setPageScrolled(true);
    } else {
      setPageScrolled(false);
    }
  };

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
  }, []);

  return (
    <Fragment>
      <div className="bg-white top-0 inset-x-0 fixed z-50 shadow w-full">
        <nav
          className={`relative flex justify-center items-center px-[2.5%] transition-all duration-[0.6s] overflow-hidden ${
            pageScrolled
              ? "h-[64px] lg:h-[80px]"
              : "h-[86px] lg:h-[124px] desktop:h-[150px]"
          }`}
        >
          {/* For desktop. */}
          <div className="w-full h-full hidden lg:flex items-center justify-between">
            <Link to="/">
              <span className="sr-only">Company Logo</span>
              <div
                className={`logo ${
                  pageScrolled ? "scrolled h-32" : "w-32 h-40 xl:w-[200px]"
                }`}
              />
            </Link>

            {showLinks && (
              <div className="h-full">
                <ul className="h-full flex">
                  {links.map((link, index) => (
                    <li className="h-full" key={index}>
                      <Link
                        className="transition duration-300 text-green-700 hover:text-white hover:bg-green-700 h-full px-[12px] lg:px-[15px] 2xl:px-6 relative flex items-center font-semibold text-sm lg:text-base"
                        activeClassName="!text-white !bg-green-700"
                        to={link.path}
                      >
                        {link.name}
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
            )}

            <div className="flex items-center gap-4 justify-end text-center">
              <Button
                label={phoneNumber}
                variant="primary"
                link={{
                  is: true,
                  isExternal: true,
                  path: `tel:${phoneNumber}`,
                }}
              />
            </div>
          </div>

          {/* For mobile. */}
          <div
            className={`w-full relative grid ${
              isApplyPage ? "grid-cols-1" : "grid-cols-3"
            } lg:hidden items-center`}
          >
            {!isApplyPage && (
              <div className="flex items-center">
                <button onClick={toggleDrawer} aria-label="Menu Btn">
                  <MenuIcon className="text-green-700" />
                </button>
              </div>
            )}

            <div className="flex justify-center items-center">
              <Link to="/">
                <span className="sr-only">Company Logo</span>
                <div
                  className={`logo h-24 ${
                    pageScrolled ? "scrolled" : "!w-[150px]"
                  }`}
                />
              </Link>
            </div>

            <div
              className={`flex justify-end ${
                isApplyPage ? "absolute right-2" : ""
              } items-center`}
            >
              {isApplyPage ? (
                <div hidden={!pageScrolled}>
                  <Button
                    label="Call Us"
                    variant="outline"
                    link={{
                      is: true,
                      isExternal: true,
                      path: `tel:${phoneNumber}`,
                    }}
                  />
                </div>
              ) : is404Page ? (
                <Button
                  label={"Call Us"}
                  variant={"outline"}
                  link={{
                    is: true,
                    isExternal: true,
                    path: `tel:${phoneNumber}`,
                  }}
                />
              ) : (
                <Button
                  label={pageScrolled ? "Apply" : "Call Us"}
                  variant={pageScrolled ? "primary" : "outline"}
                  link={{
                    is: true,
                    isExternal: !pageScrolled,
                    path: pageScrolled ? "/apply/" : `tel:${phoneNumber}`,
                  }}
                />
              )}
            </div>
          </div>
        </nav>
      </div>

      <Drawer anchor="left" open={open} onClose={toggleDrawer}>
        <div className="w-80 px-4 py-8">
          <div className="flex justify-between items-center">
            <Link to="/">
              <span className="sr-only">Company Logo</span>
              <img
                src="/images/favicon.webp"
                className="w-16 h-auto"
                alt="Logo"
              />
            </Link>
            <button onClick={toggleDrawer} aria-label="Close Btn">
              <CloseIcon className="!font-bold !text-3xl" />
            </button>
          </div>
          <div className="mt-8">
            <ul>
              {links.map((link, index) => (
                <li className="mb-[42px]" key={index}>
                  <Link
                    className="text-[28px] text-green-700 font-medium"
                    to={link.path}
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
              <li>
                <a
                  className="bg-green-700 text-white font-bold text-lg px-6 py-3 rounded-full inline-block"
                  href={`tel:${phoneNumber}`}
                >
                  Call Us
                </a>
              </li>
            </ul>
          </div>
        </div>
      </Drawer>
    </Fragment>
  );
};

export default MainNavbar;
